import { useTranslation } from 'react-i18next'

export default function CTAs() {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col w-full max-w-xs gap-4'>
      <a
        href='https://www.gofundme.com/f/save-kherson-civilians-from-human-safari'
        target='_blank'
        rel='noreferrer'
        className='border-2 border-zinc-400 bg-black text-gray-300 py-3 rounded-sm text-xl font-medium focus:outline-none focus:ring-2 focus:ring-white'
      >
        {t('donateNow')}
      </a>

      <a
        href='https://4fund.com/krx6ar'
        target='_blank'
        rel='noreferrer'
        className='border-2 border-zinc-400 bg-black text-gray-300 py-3 rounded-sm text-xl font-medium focus:outline-none focus:ring-2 focus:ring-white'
      >
        {t('donateMonthly')}
      </a>

      {/* Smooth scroll handled automatically by CSS */}
      <a
        href='#alternative-donations'
        className='-mt-2 text-sm underline opacity-70 text-blue-400 cursor-pointer'
      >
        {t('otherWays')}
      </a>

      <a
        href='https://www.instagram.com/anti_human_safari/'
        target='_blank'
        rel='noreferrer'
        className='border-2 border-zinc-400 bg-black text-gray-300 py-3 rounded-sm text-xl font-medium focus:outline-none focus:ring-2 focus:ring-white'
      >
        {t('instagram')}
      </a>
    </div>
  )
}

export function PastFundraisers() {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col w-full max-w-xs gap-4'>
      <p className='text-gray-300'>{t('pastFundraisers')}</p>

      <a
        href='https://www.gofundme.com/f/civilians-evade-human-safari'
        target='_blank'
        rel='noreferrer'
        className='border-2 border-zinc-400 bg-black text-gray-300 py-3 rounded-sm text-xl font-medium focus:outline-none focus:ring-2 focus:ring-white'
      >
        {t('fundraiser2025')}
      </a>
    </div>
  )
}
